<template>
  <ODialog ref="dialog" :maxWidth="400" hide-if-loading>
    <v-card v-if="row != null">
      <ODialogBar title="Editar Conta" @close="$refs.dialog.$dismiss()" />

      <v-card-text class="pa-3">
        <div class="v-row children-pa-3">
          <div>
            <v-text-field
              v-model="row.email"
              label="Email"
              hide-details
            />
          </div>

          <div>
            <v-text-field
              v-model="row.fullName"
              label="Nome completo"
              hide-details
            />
          </div>

          <div>
            <OTagsInput
              label="Tags"
              v-model="row.tags"
              :items="allTags"
              />
          </div>

          <div>
            <v-text-field
              v-model="row.allowedApps"
              label="Apps permitidas"
              hint="(digite códigos de apps separadas por vírgulas)"
            />
          </div>

          <div>
            <v-textarea v-model="row.comments" label="Notas" />
          </div>
        </div>
      </v-card-text>

      <ODialogButtons
        class="pa-6"
        txtApply="OK"
        @cancel="$refs.dialog.$dismiss()"
        @apply="apply"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Account } from '@/models'
import { strings } from 'oderon-commons/src/utils'

export default {
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogBar: require('oderon-vue/cpts/ODialogBar').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default,
    OTagsInput: require('oderon-vue/cpts/OTagsInput').default
  },
  data() {
    return {
      isLoading: true,
      row: null,
      allTags: []
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.currentTab = '1'
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      let allTags = (await Account.findTagCloud()).map(x => x.code)

      // Remove o Financeiro e Aprovador para inserir no início
      allTags = allTags.filter(x => x != 'Financeiro' && x != 'Aprovador')
      allTags = allTags.sort()
      allTags.unshift('Aprovador', 'Financeiro')

      this.allTags = allTags

      if (this.id == null) {
        this.row = {}
      } else {
        let row = await Account.findById(this.id)
        if ( row.allowedApps != null ) row.allowedApps = row.allowedApps.join(',')
        this.row = row
      }
    },
    apply() {
      this.row.allowedApps = strings(this.row.allowedApps)
      this.$refs.dialog.$apply(this.row)
    }
  }
}
</script>

<style></style>
